"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const mobx_react_1 = require("mobx-react");
const mui_1 = require("tss-react/mui");
const react_error_boundary_1 = require("react-error-boundary");
// icons
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
// locals
const ErrorMessage_1 = __importDefault(require("./ErrorMessage"));
const useStyles = (0, mui_1.makeStyles)()(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));
function DialogError({ error }) {
    return (react_1.default.createElement("div", { style: { width: 800, margin: 40 } },
        react_1.default.createElement(ErrorMessage_1.default, { error: error })));
}
exports.default = (0, mobx_react_1.observer)(function JBrowseDialog(props) {
    const { classes } = useStyles();
    const { title, header, children, onClose } = props;
    const theme = (0, material_1.useTheme)();
    return (react_1.default.createElement(material_1.Dialog, { ...props },
        react_1.default.createElement(material_1.ScopedCssBaseline, null,
            react_1.default.isValidElement(header) ? (react_1.default.createElement(react_1.default.Fragment, null, header)) : (react_1.default.createElement(material_1.DialogTitle, null,
                title,
                onClose ? (react_1.default.createElement(material_1.IconButton, { className: classes.closeButton, onClick: () => {
                        // @ts-expect-error
                        onClose();
                    } },
                    react_1.default.createElement(Close_1.default, null))) : null)),
            react_1.default.createElement(material_1.Divider, null),
            react_1.default.createElement(react_error_boundary_1.ErrorBoundary, { FallbackComponent: DialogError },
                react_1.default.createElement(material_1.ThemeProvider, { theme: (0, material_1.createTheme)(theme, {
                        components: {
                            MuiInputBase: {
                                styleOverrides: {
                                    input: {
                                        // xref https://github.com/GMOD/jbrowse-components/pull/3666
                                        boxSizing: 'content-box!important',
                                    },
                                },
                            },
                        },
                    }) }, children)))));
});
